export default {
  $el: 'section',
  name: 'detailsForm',
  attrs: {
    class: 'incident-details',
  },
  if: "$severity == '1' || $severity == '2' || $severity == '3'",
  children: [
    {
      $cmp: 'Severity',
      props: {
        severity: '$severity',
      },
    },
    {
      $el: 'group',
      if: "$severity == '1' || $severity == '2' || $severity == '3'",
      children: [
        {
          $formkit: 'text',
          name: 'name',
          label: 'Your name? *',
          help: 'First and last name please',
          validation: 'required|length:3',
          validationMessages: {
            required: 'Please enter your name',
            length: 'Your name must be longer than 3 characters',
          },
        },
        {
          $formkit: 'text',
          name: 'summary',
          label: 'Incident title *',
          help: "Make it specific and descriptive e.g. 'Error shown on most (or all) product detail pages'",
          validation: 'required',
          validationMessages: {
            required: 'Please enter a title for the incident',
          },
        },
        {
          $formkit: 'text',
          name: 'link',
          label: 'Url, service or location affected by this incident? *',
          help: 'This could be an online link, description of software or a physical location?',
          validation: 'required',
          validationMessages: {
            required: 'Please enter a link for the incident',
          },
        },
        {
          $formkit: 'textarea',
          name: 'description',
          label: 'Broader description of the problem? *',
          help: 'Please be as specific as possible here. Suggested points to cover',
          validation: 'required',
          validationMessages: {
            required: 'Please enter a description of the incident',
          },
        },
        {
          $el: 'ul',
          attrs: {
            class: 'formkit-help',
          },
          children: [
            {
              $el: 'li',
              children: 'When did you notice the issue?',
            },
            {
              $el: 'li',
              children: 'Steps to re-produce the issue?',
            },
            {
              $el: 'li',
              children: " Any specific system or platform it's affecting?",
            },
          ],
        },
        {
          $formkit: 'checkbox',
          name: 'retro',
          label: 'Retro Incident?',
          help: 'Tick this box if the incident has already been resolved and you are creating this for tracking and visibility.',
          classes: {
            label: 'm-2',
          },
        },
        {
          $formkit: 'textarea',
          if: '$retro === true',
          name: 'resolutionSteps',
          label: 'Resolution steps *',
          help: 'What steps were taken to resolve the incident, this will not be communicated to the business.',
          validation: 'required',
          validationMessages: {
            required: 'Please enter resolution steps',
          },
        },
        {
          $formkit: 'textarea',
          if: '$retro === true',
          name: 'businessUpdate',
          label: 'Business update *',
          help: 'Provide relevant information which will be communicated to the business regarding the incident.',
          validation: 'required',
          validationMessages: {
            required: 'Please enter a business update',
          },
        },
        {
          $formkit: 'spinningSubmit',
          name: 'submit',
          label: 'Create Incident',
        },
      ],
    },
  ],
}
